import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';
import MultiFilterSelect from './MultiFilterSelect';
import { jsx as _jsx } from "react/jsx-runtime";
function TicketOwnerSelect(props) {
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const ticketOwnerOptions = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions.ticketOwners.toArray());

  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  const ticketOwners = useSelector(({
    zorseTicketInspector
  }) => zorseTicketInspector.filters.ticketOwners.toArray());
  const currentUserOption = useMemo(() => ticketOwnerOptions.filter(ticketOwner => ticketOwner.isCurrentUser).map(ticketOwner => ({
    text: /*#__PURE__*/_jsx("b", {
      children: I18n.text('app.filter.panel.ticketOwner.currentUser', {
        name: ticketOwner.name
      })
    }),
    value: ticketOwner.email
  })), [ticketOwnerOptions]);
  const options = useMemo(() => {
    const result = ticketOwnerOptions.filter(ticketOwner => !ticketOwner.isCurrentUser).map(ticketOwner => ({
      text: ticketOwner.name,
      value: ticketOwner.email
    })).sort((a, b) => a.text.localeCompare(b.text));
    if (currentUserOption.length) {
      result.unshift(currentUserOption[0]);
    }
    return result;
  }, [ticketOwnerOptions, currentUserOption]);
  return /*#__PURE__*/_jsx(MultiFilterSelect, {
    "data-test-id": "filter-select",
    defaultValue: ticketOwners,
    labelLangPath: "app.filter.panel.ticketOwner.label",
    onSelect: props.onSelect,
    options: options,
    placeholderLangPath: "app.filter.panel.ticketOwner.placeholder"
  });
}
TicketOwnerSelect.propTypes = {
  onSelect: PropTypes.func.isRequired
};
export default /*#__PURE__*/memo(TicketOwnerSelect);